const slugify = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

const trainerImagePool = [
  "https://images.unsplash.com/photo-1603503363848-6952525df449?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwdHJhaW5lciUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzE5MjU1NXww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/10960029/pexels-photo-10960029.jpeg",
  "https://images.pexels.com/photos/8436756/pexels-photo-8436756.jpeg",
  "https://images.pexels.com/photos/6739958/pexels-photo-6739958.jpeg",
  "https://images.pexels.com/photos/14756400/pexels-photo-14756400.jpeg",
];

const trainerCategorySeeds = [
  {
    slug: "strength-coaching",
    title: "Strength Coaching",
    role: "Strength Coach",
    summary:
      "For members focused on barbell strength, muscle building, and precise movement quality.",
    names: [
      "Ayan Khan",
      "Saif Ahmed",
      "Taimur Raza",
      "Omar Farooq",
      "Uzair Ali",
      "Daniyal Shah",
      "Rameez Iqbal",
      "Hassan Rauf",
      "Faizan Noor",
    ],
    specialties: [
      "Barbell mechanics and progressive overload systems",
      "Hypertrophy blocks for lean muscle gain",
      "Powerlifting foundations and form refinement",
      "Beginner-to-intermediate strength coaching",
      "Lower-body development and movement control",
      "Upper-body strength cycles and accessory work",
      "Form correction under fatigue and load",
      "Strength programming for consistent weekly progress",
      "Technique-led lifting for safe heavy sessions",
    ],
  },
  {
    slug: "transformation-coaching",
    title: "Transformation Coaching",
    role: "Transformation Coach",
    summary:
      "For clients who want body recomposition, visible change, and long-term routine consistency.",
    names: [
      "Hira Malik",
      "Sana Qureshi",
      "Mahnoor Ahmed",
      "Mehak Khan",
      "Laraib Aslam",
      "Areeba Javed",
      "Noor Fatima",
      "Minal Sheikh",
      "Eman Tariq",
    ],
    specialties: [
      "Fat-loss focused weekly transformation plans",
      "Body recomposition through structured gym routines",
      "Lifestyle-friendly progress tracking and accountability",
      "Women’s fitness coaching and confidence building",
      "Sustainable transformation with habit design",
      "Starter programs for new members returning to fitness",
      "Full-body toning and conditioning plans",
      "Goal-based programming for visible shape changes",
      "Member accountability systems for consistency",
    ],
  },
  {
    slug: "conditioning-coaches",
    title: "Conditioning Coaches",
    role: "Conditioning Coach",
    summary:
      "For members training stamina, athletic sharpness, and high-output energy systems.",
    names: [
      "Bilal Hussain",
      "Zain Murtaza",
      "Huzaifa Khan",
      "Abdul Rafay",
      "Talha Iqbal",
      "Haris Siddiqui",
      "Sameer Arif",
      "Ali Mustafa",
      "Shayan Haider",
    ],
    specialties: [
      "HIIT circuits and energy system development",
      "Athletic conditioning for field and court athletes",
      "Cardio planning with sustainable progression",
      "Endurance blocks with controlled recovery",
      "Explosive interval work and stamina building",
      "Conditioning plans for busy professionals",
      "Hybrid strength-cardio sessions for fat loss",
      "Metabolic training with performance tracking",
      "Fast-paced circuit design with clean technique",
    ],
  },
  {
    slug: "combat-functional",
    title: "Combat & Functional",
    role: "Functional Performance Coach",
    summary:
      "For members who enjoy dynamic movement, combat conditioning, and skill-driven training sessions.",
    names: [
      "Adeel Khan",
      "Fahad Mir",
      "Saad Waheed",
      "Kamran Zubair",
      "Imran Baig",
      "Yusuf Ali",
      "Ibrahim Hasan",
      "Waleed Qazi",
      "Hamza Sohail",
    ],
    specialties: [
      "Functional circuits with movement efficiency",
      "Combat-style conditioning and pad work drills",
      "Agility sessions for speed and coordination",
      "Core stability and rotational strength",
      "Footwork, balance, and reaction training",
      "Group energy sessions with skill progressions",
      "Dynamic warm-ups and movement-based conditioning",
      "Explosive training for athletic sharpness",
      "Punch, pull, carry, and conditioning blends",
    ],
  },
  {
    slug: "mobility-recovery",
    title: "Mobility & Recovery",
    role: "Mobility Coach",
    summary:
      "For members focused on movement quality, posture, recovery, and better long-term training health.",
    names: [
      "Mariam Abbas",
      "Rabia Saleem",
      "Ayesha Tariq",
      "Huma Irfan",
      "Komal Rehman",
      "Sidra Khan",
      "Laiba Noor",
      "Iqra Ahmed",
      "Anam Saeed",
    ],
    specialties: [
      "Mobility flows for stiff hips and shoulders",
      "Posture correction and movement resets",
      "Recovery-driven sessions between hard training days",
      "Breath-led mobility and flexibility work",
      "Corrective exercise for common training imbalances",
      "Joint-friendly routines for daily function",
      "Stretch and activation plans for better lifting form",
      "Low-impact recovery sessions with coaching guidance",
      "Movement quality improvements for long-term training",
    ],
  },
];

const trainerCategories = trainerCategorySeeds.map((category, categoryIndex) => ({
  slug: category.slug,
  title: category.title,
  role: category.role,
  summary: category.summary,
  trainers: category.names.map((name, index) => {
    const specialty = category.specialties[index];
    const slug = slugify(name);
    return {
      slug,
      name,
      role: category.role,
      specialty,
      bio: `${name.split(" ")[0]} helps Pulse Fitness members progress through ${specialty.toLowerCase()} with clear coaching, structure, and consistency.`,
      image: trainerImagePool[(categoryIndex + index) % trainerImagePool.length],
      instagram: `https://instagram.com/${slugify(`pulsefitness ${name}`)}`,
    };
  }),
}));

const realCoachProfiles = [
  {
    categoryIndex: 0,
    trainerIndex: 0,
    isRealProfile: true,
    name: "Muhammad Saad",
    role: "Lead Strength Coach",
    specialty: "Strength systems, technique refinement, and coached progression",
    bio: "Helps members build strength with confident form, structure, and steady gym progress.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ochgupmq_Muhammad%20Saad.jpeg",
  },
  {
    categoryIndex: 1,
    trainerIndex: 0,
    isRealProfile: true,
    name: "Aemal Bukhari",
    role: "Transformation Coach",
    specialty: "Body transformation, confidence building, and member accountability",
    bio: "Guides members through sustainable routines focused on visible change and long-term consistency.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/90facspw_Amal%20Bukhari.jpeg",
  },
  {
    categoryIndex: 2,
    trainerIndex: 0,
    isRealProfile: true,
    name: "Majid Khan",
    role: "Conditioning Coach",
    specialty: "Stamina building, gym-floor conditioning, and high-energy sessions",
    bio: "Keeps training focused, motivating, and results-driven for members building endurance and output.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/m3bdxapw_Majid%20Khan.jpeg",
  },
  {
    categoryIndex: 3,
    trainerIndex: 0,
    isRealProfile: true,
    name: "Umair Ansari",
    role: "Fat Loss & Strength Coach",
    specialty: "Masters in Health & Physical Education",
    bio: "🎓 Masters in Health & Physical Education Fat Loss & Strength Coach 💪 I help busy individuals get in shape with smart training, effective diet plans & proper guidance.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/603jny3f_Umair%20Ansari.jpeg",
    instagram:
      "https://www.instagram.com/umairkhanansari?igsh=ejVtamg2NzhqZGQ0&utm_source=qr",
  },
  {
    categoryIndex: 4,
    trainerIndex: 0,
    isRealProfile: true,
    name: "Sohail Ahmed",
    role: "Mobility & Recovery Coach",
    specialty: "Recovery routines, movement quality, and long-term training balance",
    bio: "Helps members train smarter with recovery-focused coaching, mobility support, and better movement habits.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/5bi8ewc5_Sohail%20Ahmed.jpeg",
  },
  {
    categoryIndex: 4,
    trainerIndex: 1,
    isRealProfile: true,
    name: "Dr. Momin Panhwar (DPT, CMT)",
    role: "Orthopedic and Sports Physiotherapist",
    specialty: "Sports-specific rehabilitation, orthopedic recovery, and corrective treatment",
    bio: "Working with multiple tertiary care hospitals with wide experience in sports specific rehabilitation.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ga3t7nt0_Dr.%20Momin%20Panhwar%20%28DPT%2C%20CMT%29.jpeg",
    instagram: "https://instagram.com/drmominpanhwarphysio",
  },
];

realCoachProfiles.forEach(({ categoryIndex, trainerIndex, ...coach }) => {
  const existingTrainer = trainerCategories[categoryIndex].trainers[trainerIndex];

  trainerCategories[categoryIndex].trainers[trainerIndex] = {
    ...existingTrainer,
    ...coach,
    slug: slugify(coach.name),
    isRealProfile: coach.isRealProfile || false,
    instagram:
      coach.instagram ||
      `https://instagram.com/${slugify(`pulsefitness ${coach.name}`)}`,
  };
});

const featuredTrainer = trainerCategories[0]?.trainers?.[0]
  ? {
      ...trainerCategories[0].trainers[0],
      role: "Lead Performance Coach",
    }
  : null;

const umairTransformationGallery = [
  {
    slug: "umair-client-1",
    title: "Transformation Spotlight",
    clientName: "Client Transformation 01",
    age: "",
    result: "Before / After",
    duration: "Umair Ansari",
    description: "A polished fat-loss and strength journey with visible physique change and stronger overall conditioning.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/7yn349a9_inm0L.jpg",
  },
  {
    slug: "umair-client-2",
    title: "Conditioning Reset",
    clientName: "Client Transformation 02",
    age: "",
    result: "Before / After",
    duration: "Umair Ansari",
    description: "Built around sustainable fat loss, better mobility, and consistency-led gym progress.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/cgksxcjb_KxQOd.jpg",
  },
  {
    slug: "umair-client-3",
    title: "Athletic Definition",
    clientName: "Client Transformation 03",
    age: "",
    result: "Before / After",
    duration: "Umair Ansari",
    description: "A hybrid plan focused on movement quality, upper-body strength, and visible athletic conditioning.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/5s52q650_eekbS.jpg",
  },
  {
    slug: "umair-client-4",
    title: "Strength Rebuild",
    clientName: "Client Transformation 04",
    age: "",
    result: "Before / After",
    duration: "Umair Ansari",
    description: "Focused on movement restoration, strength rebuilding, and confidence with controlled gym progress.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/buznsdwe_HL7y1.jpg",
  },
  {
    slug: "umair-client-5",
    title: "Power & Size Phase",
    clientName: "Client Transformation 05",
    age: "",
    result: "Before / After",
    duration: "Umair Ansari",
    description: "A muscle-building block supported by strength progressions, cleaner habits, and better body confidence.",
    image:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/nb86ddeg_eoxVc.jpg",
  },
];

const liveCoachCategories = [
  {
    slug: "strength-fat-loss-coaches",
    title: "Strength & Fat Loss Coaches",
    trainers: [
      {
        slug: slugify("Umair Ansari"),
        name: "Umair Ansari",
        category: "Strength & Fat Loss Coaches",
        role: "Fat Loss & Strength Coach",
        specialty: "Masters in Health & Physical Education",
        bio: "🎓 Masters in Health & Physical Education Fat Loss & Strength Coach 💪 I help busy individuals get in shape with smart training, effective diet plans & proper guidance.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/49r6phtz_Umair%20Ansari.jpeg",
        instagram:
          "https://www.instagram.com/umairkhanansari?igsh=ejVtamg2NzhqZGQ0&utm_source=qr",
      },
      {
        slug: slugify("Syed Aemal Ali Bukhari"),
        name: "Syed Aemal Ali Bukhari",
        category: "Strength & Fat Loss Coaches",
        role: "Fat Loss & Muscle Building Specialist",
        specialty: "Nutritionist & body transformation coaching",
        bio: "Fat loss and muscle building specialist and nutritionist. Focused on making clients not just physically fit, but mentally stronger too.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/6bg7epce_Aemal%20Bukhari.jpg.jpeg",
        instagram:
          "https://www.instagram.com/train_with_aemal?igsh=MW1qbDRndzV0ZzQyMQ==",
      },
      {
        slug: slugify("Ahmed Ishaq"),
        name: "Ahmed Ishaq",
        category: "Strength & Fat Loss Coaches",
        role: "Online Fitness Coach",
        specialty: "Remote coaching and structured fitness guidance",
        bio: "Online fitness coach focused on simple, effective routines that help clients stay consistent, leaner, and stronger through guided programming.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/a5jfmgau_Ahmed%20Ishaq.jpg.jpeg",
        instagram:
          "https://www.instagram.com/ahmad.fitness.58?igsh=MXcxeXBjaGhtaDNhNg%3D%3D&utm_source=qr",
      },
      {
        slug: slugify("Anas Irfan"),
        name: "Anas Irfan",
        category: "Strength & Fat Loss Coaches",
        role: "Fitness Trainer",
        specialty: "Fat loss, muscle gain, and strength building",
        bio: "Fitness trainer dedicated to fat loss, muscle gain, and strength building through customized diet plans and workouts built for real results.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/oo0qzneq_Anas%20Irfan.jpg.jpeg",
        instagram:
          "https://www.instagram.com/anasirfan_fitness?igsh=MWR6eGpkbm52N2xyOQ%3D%3D&utm_source=qr",
      },
      {
        slug: slugify("Omair Malik"),
        name: "Omair Malik",
        category: "Strength & Fat Loss Coaches",
        role: "ICREPS Level 3 Personal Trainer",
        specialty: "Strength training, fat loss, and muscle gain",
        bio: "ICREPS certified Level 3 Personal Trainer with 6 years of experience at Pulse Fitness, specializing in strength training, fat loss, and muscle gain.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/bjuyswt3_Omi%202.jpeg",
        instagram:
          "https://www.instagram.com/omi_malik0?igsh=MWkzbTd4bGw0b3ZnYQ==",
      },
      {
        slug: slugify("Huzaifa Siddiqui"),
        name: "Huzaifa Siddiqui",
        category: "Strength & Fat Loss Coaches",
        role: "Certified Personal Trainer",
        specialty: "Sustainable fat loss, muscle gain, and functional fitness",
        bio: "An internationally certified personal trainer with 5+ years of experience helping clients lose 15–20 pounds through sustainable fat loss, muscle gain, and functional fitness coaching.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/gdldjaki_Huzaifa%20Siddiqui.jpg.jpeg",
        instagram:
          "https://www.instagram.com/getfit_withhuzaifa?igsh=MXMyYTh0Z3E4NmJtMA%3D%3D&utm_source=qr",
      },
      {
        slug: slugify("Kabeer Qureshi"),
        name: "Kabeer Qureshi",
        category: "Strength & Fat Loss Coaches",
        role: "Fitness Trainer & Stage Athlete",
        specialty: "Fat loss, weight gain, and strength training",
        bio: "Stage athlete with 6 years of experience as a fitness trainer, specializing in fat loss, weight gain, weight lifting, and strength training with a background in sports science.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/x590yue1_Kabeer%20Qureshi.jpg.jpeg",
        instagram:
          "https://www.instagram.com/btwitskabeerr?igsh=MWVzamM1ZjJsODRjag==",
      },
      {
        slug: slugify("Muhammad Sadi"),
        name: "Muhammad Sadi",
        category: "Strength & Fat Loss Coaches",
        role: "Elite Certified Fitness Coach",
        specialty: "Strength development and physique transformation",
        bio: "Elite certified fitness coach with 9 years of experience, focused on crafting strength, discipline, and elite physiques through structured training.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/fmdr84u1_Muhammad%20Saad.jpg.jpeg",
        instagram:
          "https://www.instagram.com/muhammad.sadi.fitness?igsh=Y3J2dzRqOTUwMnQw&utm_source=qr",
      },
      {
        slug: slugify("Majid Zaman"),
        name: "Majid Zaman",
        category: "Strength & Fat Loss Coaches",
        role: "Personal Trainer & CrossFit Specialist",
        specialty: "Strength conditioning, circuit training, and fat loss",
        bio: "Specializes in personal training, strength and conditioning, CrossFit, circuit training, kettlebell work, and fat loss coaching for strong all-round fitness.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/fjpckpnm_Majid%20Zaman.jpg.jpeg",
        instagram: "https://www.instagram.com/majid.fitness1",
      },
      {
        slug: slugify("Mansoor Khan"),
        name: "Mansoor Khan",
        category: "Strength & Fat Loss Coaches",
        role: "ICREPS Level 3 Personal Trainer",
        specialty: "Men’s physique, fat loss, and strength building",
        bio: "Mr. Pakistan Men’s Physique and ICREPS Certified Level 3 Personal Trainer, passionate about helping clients build strength, lose fat, and stay consistent.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/m1sidsh4_Mansoor%20Khan.jpg.jpeg",
        instagram: "https://instagram.com/mansoorr_khan",
      },
      {
        slug: slugify("Raheel Ahmed"),
        name: "Raheel Ahmed",
        category: "Strength & Fat Loss Coaches",
        role: "Internationally Certified Personal Trainer",
        specialty: "Science-based strength training, CrossFit, and sports performance",
        bio: "Follows a science-based approach to strength training, CrossFit, functional training, sports performance, fat loss, muscle building, customized diet plans, mobility, and rehab-based movement.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ux1vipak_Raheel%20Ahmed.jpeg",
        instagram:
          "https://www.instagram.com/real_raheel?igsh=MTBvcTZwbHl3YjJ0dA==",
      },
      {
        slug: slugify("Rizwan Qureshi"),
        name: "Rizwan Qureshi",
        category: "Strength & Fat Loss Coaches",
        role: "Strength Trainer",
        specialty: "Progressive strength work and physique support",
        bio: "Strength trainer focused on building solid technique, powerful movement, and consistent gym progress for clients working toward a stronger physique.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/hwo76njb_Rizwan%20Qureshi.jpg.jpeg",
        instagram:
          "https://www.instagram.com/rizwaanqureshi1?igsh=MXkwMmoyd2xidGpvdw%3D%3D&utm_source=qr",
      },
      {
        slug: slugify("Ali Muhammad Saleem"),
        name: "Ali Muhammad Saleem",
        category: "Strength & Fat Loss Coaches",
        role: "NASM Certified Personal Trainer",
        specialty: "Fat loss, strength, and functional training",
        bio: "NASM Certified Personal Trainer with 7+ years of experience. MBA-qualified and focused on smart training, fat loss, strength, and long-term results.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/zndmvq3s_Ali%20Muhammad%20Saleem.jpg",
        instagram:
          "https://www.instagram.com/alisaleem_fitness?igsh=dHhram1ibnZ2eGJp",
      },
      {
        slug: slugify("Umar Arif"),
        name: "Umar Arif",
        category: "Strength & Fat Loss Coaches",
        role: "Fitness and Longevity Coach",
        specialty: "Fat loss, behavior change, and movement restoration",
        bio: "Fitness and Longevity Coach specializing in fat loss, behavior change, and movement restoration, with 9+ years of experience in the field.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/vkxrrz1m_Umar%20Arif.jpg",
        instagram:
          "https://www.instagram.com/umarthecoach?igsh=aXM4djR4OGhodDJp",
      },
      {
        slug: slugify("Shoaib Khan"),
        name: "Shoaib Khan",
        category: "Strength & Fat Loss Coaches",
        role: "Transformational Coach",
        specialty: "Physique transformation and consistent fitness progress",
        bio: "Transformational coach focused on building stronger routines, better physiques, and long-term discipline through structured gym guidance.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/j7roia7e_Shoaib%20Khan.jpg",
        instagram:
          "https://www.instagram.com/shoaibkhanfitness?igsh=ZjdienNjOGZobWY2",
      },
    ],
  },
  {
    slug: "transformation-performance",
    title: "Transformation & Performance",
    trainers: [
      {
        slug: slugify("Ahmed Hassan"),
        name: "Ahmed Hassan",
        category: "Transformation & Performance",
        role: "Transformation Specialist & Celebrity Trainer",
        specialty: "Certified fitness coaching and nutrition advising",
        bio: "Certified fitness coach and nutrition advisor offering personalized in-club and online training programs designed to deliver real, lasting results. 💪✨",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/plnk7do0_Ahmed%20Hassan.jpeg",
        instagram:
          "https://www.instagram.com/ahmedhassan_fitness?igsh=MXFybWlyeHJwNnJjYg==",
      },
      {
        slug: slugify("Amal Balushi"),
        name: "Amal Balushi",
        category: "Transformation & Performance",
        role: "Women’s Fitness Coach",
        specialty: "Body toning, consistency, and confidence-focused training",
        bio: "Helps members build confidence with structured gym guidance, body-toning routines, and a calm coaching style focused on sustainable progress.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/0oossjdq_Amal%20Balushi.jpg.jpeg",
        instagram: "",
      },
      {
        slug: slugify("Abdul Wasay"),
        name: "Abdul Wasay",
        category: "Transformation & Performance",
        role: "Fitness Trainer",
        specialty: "General fitness coaching and gym-floor motivation",
        bio: "Fitness trainer focused on building strength, improving overall conditioning, and helping clients stay disciplined through practical gym coaching.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/98zh08yu_Abdul%20Wasay.jpeg",
        instagram: "",
      },
      {
        slug: slugify("Tabinda Khan"),
        name: "Tabinda Khan",
        category: "Transformation & Performance",
        role: "Fitness Trainer",
        specialty: "Strength training, weight loss, and overall wellness",
        bio: "A dedicated fitness trainer with 3+ years of experience in strength training, weight loss, and overall wellness, focused on delivering effective and sustainable results.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/w7qxamf9_Tabinda%20Khan.jpg.jpeg",
        instagram:
          "https://www.instagram.com/tabinda.fitness?igsh=MWRtYWJqdnVneWZ0cg%3D%3D&utm_source=qr",
      },
      {
        slug: slugify("Zainab Mansoor"),
        name: "Zainab Mansoor",
        category: "Transformation & Performance",
        role: "Certified Fitness Trainer",
        specialty: "Functional training, weight loss, and mobility",
        bio: "Certified fitness trainer specializing in functional training and weight loss, helping clients lose weight, build strength, and improve mobility.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/0srssqc8_Zainab%20Mansoor.jpg.jpeg",
        instagram:
          "https://www.instagram.com/mirha55887?igsh=d2tuN3ZqM3F2aWFm&utm_source=qr",
      },
      {
        slug: slugify("Shazzy Ali"),
        name: "Shazzy Ali",
        category: "Transformation & Performance",
        role: "Fitness Trainer",
        specialty: "General fitness coaching and physique development",
        bio: "Fitness trainer focused on helping members improve strength, conditioning, and overall physique through practical gym coaching and steady progression.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/v1l5r87c_Shazzy%20Ali.jpg.jpeg",
        instagram:
          "https://www.instagram.com/shazzyali45?igsh=cWUwYmd3NHA2eWFo&utm_source=qr",
      },
      {
        slug: slugify("Sohail Saeed"),
        name: "Sohail Saeed",
        category: "Transformation & Performance",
        role: "MMA & Self Defense Coach",
        specialty: "Combat conditioning, self-defense, and fight fitness",
        bio: "MMA and self-defense coach helping members build real confidence, sharper reactions, and better conditioning through disciplined fight-based training.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/cnx5uzjh_Sohail%20Saeed.jpg.jpeg",
        instagram:
          "https://www.instagram.com/theblastermma?igsh=MXRsMG8wMWRyNHlnZw%3D%3D&utm_source=qr",
      },
      {
        slug: slugify("Dilshad"),
        name: "Dilshad Khan",
        category: "Transformation & Performance",
        role: "Level 3 Certified Fitness Coach",
        specialty: "Calisthenics, hybrid training, and athlete performance",
        bio: "Dilshad Khan is a Level 3 certified fitness coach with 5–6 years of experience. He focuses on muscle gain, strength, athlete performance, and injury-prevention based training.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/56vtdgzs_Dilshad.png",
        instagram: "",
      },
      {
        slug: slugify("Naveed Niazi"),
        name: "Naveed Khan",
        category: "Transformation & Performance",
        role: "Certified Fitness Trainer",
        specialty: "Diet nutrition, fat loss, muscle mass, and strength",
        bio: "Certified fitness trainer with 8 years of experience in diet nutrition, fat loss, increased muscle mass, strength, personal training, and fitness planning.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/32xdc9bq_Naveed.jpg",
        instagram:
          "https://www.instagram.com/niazinaveed2?igsh=MWxucTlnbDJ4aGxobw==",
      },
      {
        slug: slugify("Faisal Sardar"),
        name: "Faisal Sardar",
        category: "Transformation & Performance",
        role: "Professional Fitness Trainer",
        specialty: "Weight loss and strength training",
        bio: "🏋️ Professional Fitness Trainer with 8+ years of experience. 🔥 Specialist in weight loss and strength training with expert guidance for your fitness journey.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/8r6h0b1j_Faisal%20Sardar.png",
        instagram: "",
      },
    ],
  },
  {
    slug: "rehab-physio-team",
    title: "Rehab & Physio Team",
    trainers: [
      {
        slug: slugify("Adnan Amin"),
        name: "Adnan Amin",
        category: "Rehab & Physio Team",
        role: "Senior Physiotherapist & Master Trainer",
        specialty: "15+ years in rehabilitation and performance coaching",
        bio: "A highly experienced rehabilitation and performance specialist who transforms clients and mentors fitness professionals, raising the standard of coaching across the team.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/04url498_Adnan%20Amin.jpg.jpeg",
        instagram:
          "https://www.instagram.com/adnan._.amin?igsh=MWVsM3VkbXB0dDk3eA==",
      },
      {
        slug: slugify("Ali Haider"),
        name: "Ali Haider",
        category: "Rehab & Physio Team",
        role: "Rehabilitation & Mobility Coach",
        specialty: "Sports injury recovery, pain management, and movement quality",
        bio: "Works with rehabilitation, mobility training, pain management, and sports injury recovery while also coaching strength and fitness with a focus on long-term results.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/pfiuiu44_Ali%20Haider%20Trainer.jpg.jpeg",
        instagram:
          "https://www.instagram.com/hyder.khan_92?igsh=MWpoZW1oa3VsdmpnYg%3D%3D&utm_source=qr",
      },
      {
        slug: slugify("Ali Sinaan"),
        name: "Ali Sinaan",
        category: "Rehab & Physio Team",
        role: "Strength & Conditioning Coach",
        specialty: "Sports rehabilitation and sports performance improvement",
        bio: "Bachelors in health exercise and sports sciences with a focus on strength and conditioning, sports rehabilitation, and improving athletic performance.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/klcuijfs_Ali%20Sinaan.jpg.jpeg",
        instagram:
          "https://www.instagram.com/alisinaanhassan?igsh=MTU3OTYyZ2dlZHNsOA==",
      },
      {
        slug: slugify("Dr. Momin Panhwar (DPT, CMT)"),
        name: "Dr. Momin Panhwar (DPT, CMT)",
        category: "Rehab & Physio Team",
        role: "Orthopedic and Sports Physiotherapist",
        specialty: "Sports-specific rehabilitation and orthopedic recovery",
        bio: "Working with multiple tertiary care hospitals with wide experience in sports specific rehabilitation.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/3ddu2agr_Dr.%20Momin%20Panhwar.jpg.jpeg",
        instagram: "https://instagram.com/drmominpanhwarphysio",
      },
      {
        slug: slugify("Dr Muhammad Zeeshan"),
        name: "Dr Muhammad Zeeshan",
        category: "Rehab & Physio Team",
        role: "Fitness & Rehab Coach",
        specialty: "Physical health, sports science, and physiotherapy",
        bio: "Graduate in Physical Health & Sports Science with a diploma in Physiotherapy. Helps clients achieve fitness goals through nutritional guidance, pain-free movement, and 8 years of sports rehab experience.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ax1an4pk_Dr.%20Muhammad%20Zeeshan.jpg.jpeg",
        instagram:
          "https://www.instagram.com/physio_zeeshan?igsh=MTJsMG0wanEybm1vdw==",
      },
    ],
  },
  {
    slug: "strength-conditioning-team",
    title: "Strength & Conditioning",
    trainers: [
      {
        slug: slugify("Hafeez Niazi"),
        name: "Hafeez Niazi",
        category: "Strength & Conditioning",
        role: "Cross-Fit and Functional Trainer",
        specialty: "Weight loss and strength conditioning",
        bio: "Fitness expert with more than 20 years of experience, specializing in cross-fit, functional training, weight loss, and strength conditioning.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/rs9wsae5_Hafeez.jpg.jpeg",
        instagram: "",
      },
      {
        slug: slugify("Hamza Hussain"),
        name: "Hamza Hussain",
        category: "Strength & Conditioning",
        role: "Performance Fitness Coach",
        specialty: "Strength development and disciplined gym progression",
        bio: "Performance-focused trainer helping members build a stronger physique through consistent workouts, gym discipline, and steady progress tracking.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/0p6e1s66_Hamza%20Hussain.jpg.jpeg",
        instagram: "",
      },
      {
        slug: slugify("Hassan Abbas"),
        name: "Hassan Abbas",
        category: "Strength & Conditioning",
        role: "Body Recomposition Coach",
        specialty: "Hypertrophy, body recomposition, and habit building",
        bio: "Focused on hypertrophy, body recomposition, and high-performance habit building. Bridges the gap between your current form and your ultimate potential.",
        image:
          "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/gsiux6qt_Hassan%20Abbas.jpg.jpeg",
        instagram:
          "https://www.instagram.com/hassannnabbas?igsh=Y3k5M2YzaHpsZXMw&utm_source=qr",
      },
    ],
  },
];

export const pulseContent = {
  navItems: [
    { label: "Home", href: "#top" },
    { label: "3D Tour", href: "#tour" },
    { label: "Classes", href: "#classes" },
    { label: "Coaches", href: "/coaches" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Membership", href: "#membership" },
    { label: "Contact", href: "#contact" },
  ],
  clubInfo: {
    club_name: "Pulse Fitness",
    hero_tagline: "Luxury performance training in the heart of DHA Phase 8.",
    location: "C180, Floor 4, Main Zulfiqar Avenue. Ph.8 D.H.A\nKarachi. Pakistan.",
    phone: "03301078573",
    whatsapp: "03301078573",
    email: "admin@pulsefitnesspk.com",
    hours: "Mon - Sat • 7:00 AM to 11:00 PM",
    intro:
      "Pulse Fitness blends elite coaching, precision programming, and a cinematic gym atmosphere for members who want serious results.",
    stats: [
      { label: "Training Zones", value: "06" },
      { label: "Signature Classes", value: "12" },
      { label: "Elite Coaches", value: "30" },
    ],
  },
  media: {
    texture: "https://images.pexels.com/photos/36833355/pexels-photo-36833355.jpeg",
    hero: "https://images.pexels.com/photos/36833355/pexels-photo-36833355.jpeg",
    tourPrimary: "https://images.pexels.com/photos/6739958/pexels-photo-6739958.jpeg",
    tourSecondary: "https://images.pexels.com/photos/14756400/pexels-photo-14756400.jpeg",
    classOne:
      "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ra4dxnwm_Strength%20Lab.jpeg",
    classTwo: "https://images.pexels.com/photos/6739958/pexels-photo-6739958.jpeg",
    trainerLead: trainerImagePool[0],
    trainerOne: trainerImagePool[1],
    trainerTwo: trainerImagePool[2],
  },
  immersiveFrames: [
    {
      slug: "arrival-lounge",
      title: "Arrival Lounge",
      description:
        "A soft, welcoming first impression with natural light, premium textures, and a retreat-like atmosphere.",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/z76su47q_Recep.png",
    },
    {
      slug: "strength-floor",
      title: "Strength Floor",
      description:
        "Open floor planning and calm materials let the equipment breathe while keeping training focused.",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/fjuboh7m_WhatsApp%20Image%202026-04-26%20at%206.42.14%20PM.jpeg",
    },
    {
      slug: "cardio-gallery",
      title: "Cardio Gallery",
      description:
        "Layered architecture and gentle depth cues make the club feel spacious, clear, and easy to explore.",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ot9cewl7_WhatsApp%20Image%202026-04-26%20at%206.41.12%20PM.jpeg",
    },
    {
      slug: "coaching-studio",
      title: "Coaching Studio",
      description:
        "A mindful zone for guided transformation, mobility work, and calm one-to-one coaching.",
      image: "https://images.pexels.com/photos/8436756/pexels-photo-8436756.jpeg",
    },
    {
      slug: "kids-rowing-performance-program",
      title: "Kids Rowing Performance Program",
      description:
        "A fun, structured rowing class that builds endurance, strength, and technique to help kids perform confidently in school competitions. 🚣‍♂️",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ervqera1_ChatGPT%20Image%20Apr%2026%2C%202026%20at%2011_11_57%20PM.png",
    },
    {
      slug: "view-from-the-gym",
      title: "View From The Gym",
      description:
        "Exercise with a calm waterfront which stretches across the horizon, Anchored yachts rest gently against a wide, reflective channel and the city rises softly in the distance.",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/hw5gomzr_ChatGPT%20Image%20Apr%2026%2C%202026%20at%2011_19_10%20PM.png",
      gallery: [
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/hw5gomzr_ChatGPT%20Image%20Apr%2026%2C%202026%20at%2011_19_10%20PM.png",
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/bx8geg8u_View%20.png",
      ],
    },
  ],
  classes: [
    {
      slug: "strength-lab",
      name: "Strength Lab",
      focus:
        "Our strength floor is built for focused training, with premium machines and free weights arranged for a smooth, distraction-free workout flow. Whether you’re building muscle, improving performance, or starting fresh, the space is designed to support serious progress in a clean, motivating environment. 💪",
      duration: "60 mins",
      level: "Intermediate",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/ra4dxnwm_Strength%20Lab.jpeg",
    },
    {
      slug: "pulse-conditioning",
      name: "Pulse Conditioning",
      focus: "High-energy intervals that build stamina, speed, and mental edge.",
      duration: "45 mins",
      level: "All Levels",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/wgednq2m_floor%204th.png",
    },
    {
      slug: "mobility-reset",
      name: "Mobility Reset",
      focus: "Recovery-driven sessions for posture, flexibility, and efficient movement.",
      duration: "40 mins",
      level: "Beginner Friendly",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/293anl5i_ChatGPT%20Image%20Apr%2026%2C%202026%20at%2010_49_05%20PM.png",
    },
    {
      slug: "dedicated-weights-area",
      name: "Dedicated Weights Area",
      focus:
        "A dedicated strength zone designed for serious training, featuring premium free weights, adjustable benches, and a clean, spacious layout for uninterrupted workouts.",
      duration: "Open Floor",
      level: "All Levels",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/j7srwwwz_ChatGPT%20Image%20Apr%2026%2C%202026%20at%2011_30_59%20PM.png",
    },
    {
      slug: "mma-self-defense-training",
      name: "MMA & Self-Defense Training",
      focus:
        "Build real confidence with guided MMA and practical self-defense sessions that improve strength, awareness, and reaction skills in a safe, structured environment. 🥊🔥",
      duration: "Studio Session",
      level: "All Levels",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/a3yjbv99_Boxing.jpeg",
    },
    {
      slug: "yoga-recovery-sessions",
      name: "Yoga & Recovery Sessions",
      focus:
        "Unwind, stretch, and reset your body with calming guided yoga designed to release tension, improve flexibility, and leave you feeling lighter, clearer, and refreshed after every session. 🧘‍♀️✨",
      duration: "Recovery Session",
      level: "All Levels",
      image:
        "https://customer-assets.emergentagent.com/job_pulse-fitness-3d/artifacts/lix96ln3_Yoga.jpeg",
    },
  ],
  trainerCategories: liveCoachCategories,
  featuredTrainer: liveCoachCategories[0]?.trainers?.[0] || featuredTrainer,
  umairTransformationGallery,
  testimonials: [
    {
      slug: "member-one",
      quote: "Pulse Fitness feels less like a gym and more like a private performance club.",
      author: "Areeb • DHA Phase 8",
    },
    {
      slug: "member-two",
      quote: "The atmosphere is premium, the coaching is focused, and the results are visible fast.",
      author: "Maham • Clifton",
    },
    {
      slug: "member-three",
      quote: "Every corner looks intentional — it motivates you before the workout even starts.",
      author: "Saad • Karachi",
    },
  ],
  membershipPlans: ["Performance", "Transformation", "Elite"],
  preferredTimes: [
    "Early Morning",
    "Morning",
    "Afternoon",
    "Evening",
    "Flexible",
  ],
};